import styled from '@emotion/styled';

import Stars from '../../Badge/Stars';

interface TableStarRattingFormatterProps {
  data?: Record<string, any>;
  dataKey?: string;
  className?: string;
}

const TableStarRattingFormatter: React.FC<TableStarRattingFormatterProps> = ({
  data,
  dataKey,
  className,
}) => {
  const label = data && data[dataKey ?? ''];
  return (
    <Container className={className}>
      <Stars numStars={label ?? 0} />
    </Container>
  );
};

export default TableStarRattingFormatter;

const Container = styled.div`
  word-break: break-word;
  width: 100%;

  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;
